import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { CalendarTask } from "./types";
import { toDateKey } from "./calendarUtils";
import CalendarTaskItem from "./CalendarTaskItem";

interface Props {
  currentDate: Date;
  tasksByDate: Map<string, CalendarTask[]>;
  onTaskClick: (task: CalendarTask) => void;
}

export default function CalendarDayView({ currentDate, tasksByDate, onTaskClick }: Props) {
  const { t } = useTranslation("Common");

  const tasks = useMemo(() => {
    const key = toDateKey(currentDate);
    return tasksByDate.get(key) ?? [];
  }, [currentDate, tasksByDate]);

  return (
    <div className="flex-1 flex flex-col">
      {tasks.length === 0 ? (
        <div className="flex-1 flex items-center justify-center">
          <p className="text-body-regular-md content-base-low">{t("calendar.noTasks")}</p>
        </div>
      ) : (
        <div className="flex flex-col gap-1 py-2">
          {tasks.map((task) => (
            <CalendarTaskItem key={task.id} task={task} onClick={() => onTaskClick(task)} />
          ))}
        </div>
      )}
    </div>
  );
}
